import MenuItem from '@/domain/data/menu/MenuItem';

const LIMIT_ITEMS_LENGTH = 5;

export default class SubMenu {
  constructor(model) {
    this.groupTitleLabel = '';
    this.groupSubTitleLabel = '';
    this.limitItemsLength = LIMIT_ITEMS_LENGTH;
    this.items = [];

    Object.assign(this, model);
    this.instantiateItems();
  }

  instantiateItems() {
    this.items = this.items.map(item => new MenuItem(item));
  }

  setLimitItemsLength(value) {
    this.limitItemsLength = value;
  }

  getItemsList() {
    if (!this.limitItemsLength) return this.items;
    return (this.items || []).slice(0, this.limitItemsLength);
  }
}
